import { localStorageAdapter } from "./LocalStorageAdapter";
import { Base64 } from "js-base64";

const storageSize = 5;
const loginStorageName = "continue_watching";
const nonLoginStorageName = "non_login_recent_watch";

export class RecentContentProfileStorage {
  static get() {
    try {
      let storageData = this.localStorage().getItem(this.storageName())

      return JSON.parse(storageData).slice(0, this.storageSize()) || [];
    } catch(e) {
      return [];
    }
  }

  static toQueryParam() {
    let localContents = this.get()
    let encodedContents = Base64.encode(JSON.stringify(localContents));

    return `contents=${encodedContents}`;
  }

  static storageName() {
    if (!window.isUserSignedIn) {
      return nonLoginStorageName;
    }

    return loginStorageName;
  }

  static storageSize() {
    return storageSize;
  }

  static localStorage() {
    return localStorageAdapter(this.storageName());
  }
}
